export default __webpack_public_path__ + "static/media/Banner_01.fa4fd71f.png";